exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".double-bounce {\n  width: 27px;\n  height: 27px;\n\n  position: relative;\n}\n\n.double-bounce1, .double-bounce2 {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: #333;\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: bounce 2.0s infinite ease-in-out;\n}\n\n.double-bounce2 {\n  animation-delay: -1.0s;\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: scale(0.0);\n    -webkit-transform: scale(0.0);\n  } 50% {\n    transform: scale(1.0);\n    -webkit-transform: scale(1.0);\n  }\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./~/react-spinkit/css/double-bounce.css
// module id = 345
// module chunks = 0